import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { ResponseError } from 'models/common/respone.model';

export type UseDeleteMasterMenuParams = {
    sid?: string;
    id?: string;
}

export function useDeleteMasterMenu(
    options?: UseMutationOptions<
        ResponseError,
        AxiosError<ResponseError>,
        UseDeleteMasterMenuParams
    >
) {
    return useMutation({
        mutationFn: params => {
            const accessToken = localStorage.getItem('WF_APPLICATION');
            return axios.delete('/v1/configuration/workflow/menu', {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                params
            });
        },
        ...options
    });
}
